import { ViewModel,View, ViewModelMessage, ObservableArray } from "binder"
import { ChangeThemeMessage } from "src/common/mainWindow/mainWindow-viewModel";
import { distinct } from "src/common/utilities";
import { CssClassListExtractor } from "src/formBuilder/formBuilder/utilities/cssClassListExtractor";
import { CurrentCredentials } from "src/server/currentCredentials";
import { ServerConnection } from "src/server/serverConnection";
import { MediaSelector } from "uicomponents";
import  { AuthenticationView } from "./authentication-view"
import { AuthenticationPhoneView } from "./authenticationPhone/authenticationPhone-view";
declare var authenticationDebugDefaultUserName:string;
declare var authenticationDebugDefaultPassword:string;

export class AuthenticationViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.username = authenticationDebugDefaultUserName ?? "";
        this.password = authenticationDebugDefaultPassword ?? "";

        let compatibilityIssues = new BrowserCompatibilityChecker().validate();
        if(compatibilityIssues.length>0){
            this.hasCompatibilityIssues = true;
            this.browserCompatibilityIssues = compatibilityIssues.join("\r\n");
        }else{
            this.hasCompatibilityIssues = false;
        }
    }
    GetDefaultView(): View <ViewModel> {
        return MediaSelector.GetView({
            default : ()=>new AuthenticationView(),
            landscapePhone : ()=>new AuthenticationPhoneView(),
            portraitPhone : ()=>new AuthenticationPhoneView(),
        })
        return new AuthenticationView();
    }
    public getTypeId(): string {
        return "VM-7926838A-3D10-4433-913E-C9A1E1AC7794"
    }

    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isPasswordWrong(v: boolean) { this._isPasswordWrong = v; } public get isPasswordWrong(): boolean { return this._isPasswordWrong;} private _isPasswordWrong: boolean;
    public set browserCompatibilityIssues(v: string) { this._browserCompatibilityIssues = v; } public get browserCompatibilityIssues(): string { return this._browserCompatibilityIssues;} private _browserCompatibilityIssues: string;
    public set hasCompatibilityIssues(v: boolean) { this._hasCompatibilityIssues = v; } public get hasCompatibilityIssues(): boolean { return this._hasCompatibilityIssues;} private _hasCompatibilityIssues: boolean;
    
    
    async login(){
        try {
            this.isLoading = true;
            this.isPasswordWrong = false;
            let result = await ServerConnection.callServerWithUsernameAndPassword('Complex/AuthenticationServices/Login',{},this.username,this.password);
            if(result.IsSuccessful){
                CurrentCredentials.username = this.username;
                CurrentCredentials.password = this.password;
                CurrentCredentials.personnelFullName = result.PersonnelFullName ?? "";
                CurrentCredentials.personnelCode = result.PersonnelCode ?? "";
                CurrentCredentials.personnelId = result.PersonnelId;
                this.handleMessage(new LoginCompletedMessage());
                let themeId = result.CurrentTheme;
                let changeThemeRequest = new ChangeThemeMessage();
                changeThemeRequest.background = themeId;
                changeThemeRequest.shallSave = false;
                this.handleMessage(changeThemeRequest);
            }else{
                this.isPasswordWrong = true;
            }
        } catch (ex) {
            this.isPasswordWrong = true;
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class LoginCompletedMessage extends ViewModelMessage{ }

class BrowserCompatibilityChecker{
    public validate():string[]{
        let result : string[] = [];
        if((CSS.supports("backdrop-filter","blur(40px)")==false && CSS.supports("-webkit-backdrop-filter","blur(40px)")==false)){
            result.push('مرورگر شما به روز نمی باشد. لطفا از آخرین نسخه های Edge, Chrome, Firefox, safari استفاده کنید.');
        }
        return result;
    }
}